import script from "./Repair07Paint.vue?vue&type=script&setup=true&lang=js"
export * from "./Repair07Paint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__